import { useState, useContext, useEffect } from 'react';
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
} from '@mui/material';
import AuthContext from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import liff from '@line/liff';
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login, loginLineToken, setLineId, lineId } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    liff
      .init({
        liffId: import.meta.env.VITE_LIFF_ID,
      })
      .then(async () => {
        console.log('LIFF init succeeded');
        liff
          .getProfile()
          .then((profile) => {
            setLineId(profile.userId);
          })
          .catch((e) => {
            setLineId(import.meta.env.VITE_MOCK_LINE_ID);
          });
        const idToken = liff.getIDToken();
        if (idToken) {
          loginLineToken(idToken).then(() => {
            const redirectTo = searchParams.get('redirect') || '/contracts';
            navigate(redirectTo, { replace: true });
          });
        }
      })
      .catch((e) => {
        setMessage(`พบข้อผิดพลาด: ${e.message}`);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    login(username, password, lineId)
      .then(() => {
        setTimeout(() => {
          const redirectTo = searchParams.get('redirect') || '/';
          navigate(redirectTo, { replace: true });
        }, 1000);
      })
      .catch(() => {
        setMessage('เลขที่บัตรประชาชนหรือเบอร์โทรศัพท์มือถือไม่ถูกต้อง');
        setOpen(true);
      });
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label="เลขที่บัตรประชาชน"
            variant="outlined"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <TextField
            label="เบอร์โทรศัพท์มือถือ"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {/* <TextField
            label="Line Id"
            variant="outlined"
            fullWidth
            value={lineId}
            required
          /> */}
          <Button type="submit" variant="contained" color="primary" fullWidth>
            เข้าสู่ระบบ
          </Button>
        </Box>
      </Paper>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Login;
